import { nodeReducer } from '../node'
import { cursorReducer } from '../cursor'
import { userReducer } from '../user'
import { syncReducer } from '../sync'

export default (state = {}, action) => {
    return {
        nodes: nodeReducer(state.nodes, action),
        cursor: cursorReducer(state.cursor, { ...action, nodes: state.nodes }),
        user: userReducer(state.user, action),
        sync: syncReducer(state.sync, action)
    }
}
